<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="staffConfig.isOpen"
    id="update-staff"
  >
    <div class="mt-2 flex items-center justify-between px-6">
      <h4 class="text-2xl font-bold">Update staff</h4>
      <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <div class="sidebar-content p-6">
      <div class="info-form">
        <div class="update-staff-avatar-container">
          <!-- <label class="vs-input--label">Avatar</label> -->
          <h4 class="text-lg font-bold">Profile picture</h4>
          <avatar-uploader
            class="my-avatar-uploader"
            v-if="staffConfig.isOpen"
            :user="staffData"
            :key="staffData.user_id"
            @uploaded-done="handleUploaded"
          ></avatar-uploader>
          <!-- <vs-upload automatic action="http://api.gci.net/v1/gocheckin/staff/form/upload" :headers="uploadHeader" @on-success="successUpload" :limit="1" fileName="file"/> -->
        </div>

        <!-- <h4 class="text-lg font-bold">Type</h4>
        <div class="flex mb-base">
          <vs-radio class="mr-base" v-model="staff_type" vs-name="staff_type" vs-value="staff">staff</vs-radio>
          <vs-radio class="mr-base" v-model="staff_type" vs-name="staff_type" vs-value="manager">manager</vs-radio>
          <vs-radio class="mr-base" v-model="staff_type" vs-name="staff_type" vs-value="sub-owner">sub-owner</vs-radio>
          <vs-radio class="mr-base" v-model="staff_type" vs-name="staff_type" vs-value="owner">owner</vs-radio>
        </div> -->


        <div class="flex mt-3">
          <div class="w-1/2 pr-2">
            <h4 class="text-lg font-bold">Name</h4>
            <vs-input
              :maxlength="30"
              v-validate="{required: true, regex: '^[a-zA-Z0-9 ]+$'}"
              name="staff_name"
              v-model="staff_name"
              class="w-full"
              :danger="errors.has('staff_name')"
              :danger-text="StringHelper.getErrorName(errors.first('staff_name'), 'staff_name')"
              placeholder="Name"
            />
          </div>
          <div class="w-1/2 pl-3">
            <h4 class="text-lg font-bold">Code</h4>
            <vs-input
              v-if="!has_err"
              :maxlength="6"
              v-validate="'required'"
              name="staff_code"
              v-model="staff_code"
              class="w-full"
              :danger="errors.has('staff_code')"
              danger-text="The code field is required"
              placeholder="Code"
              v-on:keypress="isNumber($event)"
              @input="isExistCode = false, has_err = false"
            />
            <vs-input
              v-else
              :maxlength="6"
              v-validate="'required'"
              name="staff_code"
              v-model="staff_code"
              class="w-full min-length-err"
              :danger="has_err"
              :danger-text="`${error_message}`"
              placeholder="Code"
              v-on:keypress="isNumber($event)"
              @input="isExistCode = false, has_err = false"
            />
          </div>
        </div>

        <h4 class="text-lg font-bold mt-base">Nick name</h4>
        <vs-input v-model="staff_nick_name" class="w-full min-length-err" placeholder="Nick name" />

        <!-- <h4 class="text-lg font-bold mt-base">Password</h4>
        <vs-input v-model="password" class="w-full min-length-err" type="password" placeholder="Password" /> -->

        <h4 class="text-lg font-bold mt-base">Cell</h4>
        <vs-input v-model="staff_cell" class="w-full min-length-err" placeholder="Cell" :maxlength="14" v-mask="'(###) ###-####'" type="tel" name="cell" :danger="has_err_phone" :danger-text="err_phone" 
            @input="has_err_phone = false" v-on:keypress="isPhoneNumber($event)" :key="cell_key" />
        
        <!-- <vs-input v-model="staff_cell" class="w-full min-length-err" placeholder="Cell" :maxlength="14" v-mask="'(###) ###-####'" type="tel" name="cell" :danger="has_err_phone" :danger-text="err_phone" 
            @input="has_err_phone = false" v-on:keypress="isNumber($event)" :key="cell_key" /> -->
        <!-- <vs-input v-model="staff_cell" class="w-full min-length-err" placeholder="Cell" /> -->


        <h4 class="text-lg font-bold mt-base">Email</h4>
        <vs-input
          v-if="!has_err_email"
          :maxlength="30"
          v-validate="'email'"
          name="email"
          v-model="email"
          class="w-full min-length-err"
          :danger="errors.has('email')"
          danger-text="Please enter a valid email"
          placeholder="Email"
          @input="has_err_email = false"
          v-on:keypress="StringHelper.validateEmailChar($event, email)"
        />
        <vs-input
          v-else
          :maxlength="30"
          v-validate="'email'"
          name="email"
          v-model="email"
          class="w-full min-length-err"
          :danger="has_err_email"
          :danger-text="`${error_message_email}`"
          placeholder="Email"
          @input="has_err_email = false"
          v-on:keypress="StringHelper.validateEmailChar($event, email)"
        />

        <h4 class="text-lg font-bold mt-base">Address</h4>
        <vs-input v-model="staff_address" class="w-full min-length-err" placeholder="Address" />

        <!-- <span class="text-danger text-xs error-text-input" v-show="isExistCode">This code already exists</span> -->
        <!-- <span class="text-danger text-xs error-text-input" v-show="has_err">This code {{error_message}}</span> -->

        <div v-if="permissionList && permissionList.length > 0">
          <h4 class="text-lg font-bold mt-base mb-4">Permission</h4>
          <!-- <div class="flex align-center mb-4">
            <vs-switch v-model="permission.turn" />
            <p class="ml-3" :class="`${permission.turn ? 'text-primary' : 'text-grey-custom'}`">Turn</p>
          </div>
          <div class="flex align-center mb-4">
            <vs-switch v-model="permission.income" />
            <p class="ml-3" :class="`${permission.income ? 'text-primary' : 'text-grey-custom'}`">Income</p>
          </div>
          <div class="flex align-center mb-4">
            <vs-switch v-model="permission.staff_daily_income" />
            <p class="ml-3" :class="`${permission.staff_daily_income ? 'text-primary' : 'text-grey-custom'}`">Staff Daily Income</p>
          </div>
          <div class="flex align-center mb-4">
            <vs-switch v-model="permission.payroll" />
            <p class="ml-3" :class="`${permission.payroll ? 'text-primary' : 'text-grey-custom'}`">Payroll</p>
          </div>
          <div class="flex align-center">
            <vs-switch v-model="permission.batch_history" />
            <p class="ml-3" :class="`${permission.batch_history ? 'text-primary' : 'text-grey-custom'}`">Batch History</p>
          </div> -->
          <div class="flex align-center mb-4" v-for="(permission, index) in permissionList" :key="index">
            <vs-switch v-model="permission.status" />
            <p class="ml-3" :class="`${permission.status ? 'text-primary' : 'text-grey-custom'}`">{{ permission.name }}</p>
          </div>
        </div>

        <div>
          <!-- <label class="text-sm mb-2">Staff color</label> -->
          <h4 class="text-lg font-bold mt-base mb-2">Color</h4>
          <ul class="clearfix flex flex-wrap">
            <!-- Color Square -->
            <li
              v-for="(color, index) in themeColors"
              :key="color"
              :style="{backgroundColor: color}"
              class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left position-relative"
              @click="updatePrimaryColor(color)"
              :class="{'blur-item': isNewColor || (index >= 0 && index < 20)}"
            >
              <i
                class="vs-icon material-icons text-white font-bold text-2xl translate-center"
                v-if="color == primaryColor"
              >check</i>
            </li>

            <!-- Custom Color Square -->
            <!-- <li
              :style="{backgroundColor: customColor}"
              :class="{'shadow-outline': customColor == primaryColor}"
              class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left position-relative"
              @click="updatePrimaryColor(customColor)"
            >
              <i
                class="vs-icon material-icons text-white font-bold text-2xl translate-center"
                v-if="customColor == primaryColor"
              >check</i>
            </li>

            <li class="float-left">
              <input
                class="w-10 cursor-pointer h-10 rounded-lg m-2"
                v-model="customColor"
                type="color"
              />
            </li> -->
          </ul>
        </div>

        <!-- <label class="vs-input--label mb-4">Change status</label> -->
        <h4 class="text-lg font-bold mt-base mb-4">Status</h4>
        <ul class="switch-container">
          <li class="flex align-center">
            <vs-switch v-model="staff_status" @click.stop="switchActive" />
            <p class="ml-3">
              <span class="text-primary" v-if="staff_status">Active</span>
              <span class="text-grey-custom" v-else>Inactive</span>
            </p>
          </li>
        </ul>
      </div>
    </div>

    <div class="vx-row justify-center my-3" slot="footer">
      <vs-button type="filled" color="primary" @click="updateStaff" style="min-width: 140px;">Save</vs-button>
      <vs-button type="border" color="danger" @click="closeSidebar" style="min-width: 140px;">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { StringHelper } from "../../models/string_helper";
export default {
  name: "vs-update-staff",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue")
  },
  props: {
    staffConfig: {
      type: Object,
      required: true
    },
    staffData: {
      type: Object,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    },
    filter: {
      type: Number
    }
  },
  data() {
    // console.log(this.staffData)
    // let customColor = '#3DC9B3';
    // let currentColor = this.staffData.color_code;
    // console.log(this.customColor)
    // let list_color = this.$store.getters["staffList/themeColors"];
    // for(let i = 0; i < list_color.length; i++) {
    //   if(list_color[i].toUpperCase() == this.currentColor.toUpperCase()) {
    //     this.customColor = this.currentColor;
    //     break;
    //   }
    // }
    // let customColor = this.checkColorInList(this.currentColor) ? '#3DC9B3' : this.currentColor;
    // let customColor = "#3DC9B3";
    let currentColor = "";
    if (this.staffData) {
      // currentColor = this.staffData.color_code;
      currentColor = this.checkColorInList(this.staffData.color_code) ? this.staffData.color_code : '#9E4CEF';
      // customColor = this.checkColorInList(currentColor)
      //   ? "#3DC9B3"
      //   : currentColor;
    }
    return {
      name: this.staffData.name,
      code: StringHelper.staffCodeFormat(this.staffData.code),
      status: this.staffData.status,
      StringHelper,
      // currentColor: this.staffData.color_code,
      // customColor: '#3DC9B3',
      currentColor,
      // customColor,
      themeColors: this.$store.getters["staffList/themeColors"],
      isExistCode: false,
      isShortCode: false,
      error_message: "",
      error_message_email: "",
      has_err: false,
      has_err_email: false,
      err_phone: "",
      has_err_phone: false,
      image: {},
      isOpenLoading: false,
      email: "",
      email_temp: '',
      staff_type: 'staff',
      password: '',
      cell: this.staffData.phone,
      nick_name: this.staffData.nickname,
      address: this.staffData.address,
      cell_key: 0,
      permissionList: []
      // status: false
    };
  },
  computed: {
    staff_name: {
      get() {
        return this.name;
      },
      set(value) {
        this.name = value;
      }
    },
    staff_code: {
      get() {
        return this.code;
      },
      set(value) {
        this.code = value;
      }
    },
    staff_status: {
      get() {
        return this.status;
      },
      set(value) {
        this.status = value;
      }
    },
    staff_nick_name: {
      get() {
        return this.nick_name;
      },
      set(value) {
        this.nick_name = value;
      }
    },
    staff_address: {
      get() {
        return this.address;
      },
      set(value) {
        this.address = value;
      }
    },
    staff_cell: {
      get() {
        return this.cell;
      },
      set(value) {
        this.cell = value;
      }
    },
    primaryColor: {
      get() {
        return this.currentColor;
      },
      set(value) {
        this.currentColor = value;
      }
    },
    uploadHeader() {
      return {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
        mode: "no-cors"
      };
    },
    config() {
      return this.$store.getters["auth/config"];
    },
    isNewColor() {
      return this.config && this.config.new_color == 1;
    }
  },

  watch: {
    staffConfig: {
      immediate: true,
      deep: true,
      handler() {
        this.name = this.staffData.name;
        this.code = StringHelper.staffCodeFormat(this.staffData.code);
        this.status = this.staffData.status;
        // this.currentColor = this.staffData.color_code;
        this.currentColor = this.checkColorInList(this.staffData.color_code) ? this.staffData.color_code : '#9E4CEF';
        // this.customColor = this.checkColorInList(this.currentColor)
        //   ? "#FF9CBB"
        //   : this.currentColor;
        this.image.image_url = this.staffData.image_url;
        this.image.delete_image_url = this.staffData.delete_image_url;
        this.email = this.staffData.email;
        this.nick_name = this.staffData.nickname;
        // this.cell = this.staffData.phone;
        this.cell = StringHelper.phoneNumberFormat(this.staffData.phone);
        this.address = this.staffData.address;
        this.permissionList = this.getPermissionList(this.staffData.permission);
        // this.isExistCode = false;
        this.has_err = false;
        this.has_err_email = false;
        this.has_err_phone = false;
        this.errors.clear();
        this.cell_key++;
        // this.customColor = this.checkColorInList(this.currentColor) ? '#3DC9B3' : this.currentColor;

        // let list_color = this.$store.getters["staffList/themeColors"];
        // for(let i = 0; i < list_color.length; i++) {
        //   if(list_color[i] == this.currentColor) {
        //     this.customColor = this.currentColor;
        //     break;
        //   } else {
        //     this.customColor = '#3DC9B3';
        //   }
        // }
        if (this.staffConfig.isOpen) {
          document.body.classList.add("overflow-hidden");
          document.body.style.position = "";
          document.body.style.top = "";
          window.scrollTo(0, parseInt(scrollY || "0") * -1);
          if(this.staffData.email != '') {
            this.email_temp = this.staffData.email;
          } else {
            this.email = this.email_temp;
          }
        } else {
          document.body.classList.remove("overflow-hidden");
        }
      }
    }
  },

  methods: {
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: 'Update staff failed',
          //   color:'danger',
          //   position:'top-right'})
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Update staff failed",
            acceptText: "OK"
          });
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
    },
    closeLoading() {
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    getPermissionList(data) {
      // let permissionListData = this.$store.getters["staffList/permissionList"];
      let result = [];
      if(data && data.length > 0) {
        for(let i = 0; i < data.length; i++) {
          result.push({ id: data[i].id, name: data[i].name, status: data[i].status == 1 ? true : false });
          // let item = { id: data[i].permission_id, status: data[i].status == 1 ? true : false }
          // for(let j = 0; j < permissionListData.length; j++) {
          //   if(permissionListData[j].id == data[i].permission_id) {
          //     item.name = permissionListData[j].name;
          //     result.push(item);
          //     continue;
          //   }
          // }
        }
      }
      return result;
    },
    myMaskedNumber(str) {
      let result = "(";
      let number = ('' + str).replace(/[^\d]/g, '');
      result += number.substr(0, 3);
      if(result.length == 4) {
        result += ") ";
      }
      result += number.substr(3, 3);
      if(result.length == 9) {
        result += "-";
      }
      result += number.substr(6);
      this.staff_cell = result;
      return result;
    },
    isPhoneNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        if(charCode >= 48 && charCode <= 57 && this.staff_cell.length < 14) {
          this.myMaskedNumber(this.staff_cell);
        }
        return true;
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    checkColorInList(color) {
      let list_color = this.$store.getters["staffList/themeColors"];
      if (list_color && color) {
        for (let i = 0; i < list_color.length; i++) {
          if (list_color[i].toUpperCase() == color.toUpperCase()) {
            return true;
          }
          //  if(list_color[i] == color) {
          //   return true;
          // }
        }
      }
      return false;
    },
    updatePrimaryColor(color) {
      this.primaryColor = color;
      // this.$vs.theme({ primary: color });
    },
    switchActive() {
      this.status = this.status;
    },
    closeSidebar() {
      this.$emit("CloseSidebar");
    },
    handleUploaded(data) {
      this.image = data;
    },
    validateEmail(email) {
      // eslint-disable-next-line
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    },
    updateStaff() {
      // console.log(this.errors);
      let valid_email = this.validateEmail(this.email);
      let phone_num = ('' + this.cell).replace(/[^\d]/g, '');
      if (
        this.name != "" &&
        this.code.length >= 3
        && (valid_email == true || this.email == '')
        && this.errors.first('staff_name') == undefined
        && (phone_num.length == 10 || phone_num == '')
      ) {
        if (!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        const staff = {
          staff_name: this.name,
          staff_code: this.code,
          is_active: this.status ? 1 : 0,
          id: this.staffData.user_id,
          page: this.currentPage,
          color_code: this.primaryColor,
          "per-page": this.itemsPerPage,
          sort: "user_id",
          filter: this.filter,
          image_url: this.image.image_url,
          delete_image_url: this.image.delete_image_url,
          email: this.email,
          address: this.address,
          phone: phone_num,
          nick_name: this.nick_name,
        };
        let list_permission = [];
        if(this.permissionList && this.permissionList.length > 0) {
          for(let i = 0; i < this.permissionList.length; i++) {
            list_permission.push({
              id: this.permissionList[i].id,
              status: this.permissionList[i].status ? 1 : 0
            });
          }
        }
        staff.list_permission = list_permission;
        // if(this.filter) {
        //   staff.filter = this.filter;
        // }
        this.$store
          .dispatch("staffList/UPDATE_STAFF", staff)
          .then(() => {
            const staff_data = {
              user_id: this.staffData.user_id,
              name: this.name,
              code: this.code,
              // status: this.status,
              status: this.status ? 1 : 0,
              color_code: this.primaryColor,
              image_url:
                this.image.image_url != "deleted" ? this.image.image_url : null,
              delete_image_url:
                this.image.delete_image_url != "deleted"
                  ? this.image.delete_image_url
                  : null,
              email: this.email != '' ? this.email : this.email_temp,
              address: this.address,
              phone: phone_num,
              nickname: this.nick_name,
              // user_id: this.staffData.user_id
              // filter: this.filter
            };
            list_permission = [];
            if(this.permissionList && this.permissionList.length > 0) {
              for(let i = 0; i < this.permissionList.length; i++) {
                list_permission.push({
                  id: this.permissionList[i].id,
                  status: this.permissionList[i].status ? 1 : 0,
                  name: this.permissionList[i].name
                });
              }
            }
            staff_data.permission = list_permission;
            this.$emit("UpdateStaff", staff_data);
            if (this.has_err == false && this.has_err_email == false) {
              this.$emit("CloseSidebar");
              // this.isExistCode = false;
            }
            this.closeLoading();
            // this.$store.dispatch("staffList/GET_STAFF_LIST");

            this.$vs.notify({
              title: "Notification",
              text: "Update Staff Success",
              color: "success",
              position: "top-right"
            });
          })
          .catch(err => {
            // if(err.includes('already')) {
            //   this.isExistCode = true;
            // }
            if (err.code) {
              this.error_message = err.code[0];
              this.has_err = true;
            }
            if (err.email) {
              this.error_message_email = err.email[0];
              this.has_err_email = true;
            }
            this.closeLoading();
          });
      } else {
        // if (this.code.length != 3) {
        if (this.code.length < 3) {
          this.has_err = true;
          // this.error_message = "The code must contain exactly 3 digits.";
          this.error_message = "Staff code must contain at least 3 digits.";
        }
        if(phone_num.length != 10 && phone_num.length != 0) {
          this.has_err_phone = true;
          this.err_phone = "Phone number must contain exactly 10 digits.";
        }
      }
    }
  }
  // created() {
  //   console.log('abc');
  //   this.name = this.staffData.name;
  //   this.code = this.staffData.code;
  //   console.log(this.staffData.name);
  // }
};
</script>
